import { Box, Typography } from '@mui/material';

import {
  isEmptyMedicalNote,
  isRichHtml,
  normalizePlainText,
  prepareMedicalNoteHtmlForDisplay,
} from 'utils/medicalNoteContent';

import './quillEditor.css';
import './quillViewerContent.css';

interface Props {
  content: string;
  emptyMessage?: string;
  variant?: 'body2' | 'caption';
}

const PlainTextViewer = ({
  content,
  variant = 'body2',
}: {
  content: string;
  variant?: 'body2' | 'caption';
}) => {
  const noteLines = normalizePlainText(content).split('\n');

  return (
    <>
      {noteLines.map((line, idx) => (
        <Typography
          key={idx}
          variant={variant}
          lineHeight="22px"
          whiteSpace="pre-wrap"
          sx={{
            py: 0.8,
            borderBottom:
              idx === noteLines.length - 1
                ? 'none'
                : '1px solid rgba(0, 0, 0, 0.08)',
          }}
        >
          {line || '\u00A0'}
        </Typography>
      ))}
    </>
  );
};

const QuillViewer = ({
  content,
  emptyMessage = '작성된 처방/메모가 없습니다.',
  variant = 'body2',
}: Props) => {
  const rawNote = content ?? '';

  if (isEmptyMedicalNote(rawNote)) {
    return (
      <Typography variant={variant} color="#00000061">
        {emptyMessage}
      </Typography>
    );
  }

  if (!isRichHtml(rawNote)) {
    return <PlainTextViewer content={rawNote} variant={variant} />;
  }

  const sanitizedHtml = prepareMedicalNoteHtmlForDisplay(rawNote);

  if (!sanitizedHtml.trim()) {
    return (
      <Typography variant={variant} color="#00000061">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Box
      className="quill-viewer-root"
      sx={{ '& .MuiTypography-root': { fontSize: 'inherit' } }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default QuillViewer;
